import LoadMore from '@support/*       */
import {sendEventToTrackingServer} from '@utils/tracking'

class SupportPage {
    private static readonly URL_PARAM_FOCUSSED_DIALOG_PREV_URL = 'focussedDialogPrevUrl'
    private readonly $documentObject: Document
    private readonly _windowObject: Window
    private readonly $orderList: HTMLUListElement | null
    private readonly $loadMoreLink: HTMLAnchorElement | null
    private readonly SCROLL_POSITION_STORAGE_KEY: string = 'contact_contact_support_scrollposition'
    private readonly $backButton: HTMLButtonElement | null

    private constructor(documentObject: Document, windowObject: Window) {
        this.$documentObject = documentObject
        this._windowObject = windowObject
        this.$orderList = this.$documentObject.querySelector('[data-js-hook="con_support__order-list"]')
        this.$loadMoreLink = this.$documentObject.querySelector('[data-js-hook="con_support__load-more-link"]')
        this.$backButton = this.$documentObject.querySelector('[data-js-hook="contact-support-start-cancel-button"]') || null
        this.registerEventTracking()
    }

    private bindScrollPositionRetention() {
        window.addEventListener('beforeunload', () => {
            window.sessionStorage.setItem(this.SCROLL_POSITION_STORAGE_KEY, Math.round(window.scrollY).toString())
        })
    }

    private restoreLastScrollPositionIfAvailable() {
        history.scrollRestoration = 'manual'
        const lastScrollPositionOrNull = window.sessionStorage.getItem(this.SCROLL_POSITION_STORAGE_KEY)
        const scrollPosition = parseInt(lastScrollPositionOrNull!)
        if (lastScrollPositionOrNull != null && !isNaN(scrollPosition)) {
            window.scrollTo(window.scrollX, scrollPosition)
        }
        window.sessionStorage.removeItem(this.SCROLL_POSITION_STORAGE_KEY)
    }

    private initLoadMore() {
        if(this.$loadMoreLink && this.$orderList) {
            LoadMore.initialize(this.$documentObject, this.$orderList, this.$loadMoreLink)
        }
    }

    private registerEventTracking() {
        if (this.$loadMoreLink) {
            sendEventToTrackingServer({
                contact_Activity: 'show_moreArticles'
            })
            this.$loadMoreLink.addEventListener('click', () => {
                sendEventToTrackingServer({
                    contact_Activity: 'click_moreArticles'
                })
            })
        }
        this.$documentObject.addEventListener('scroll', () => {
            sendEventToTrackingServer({
                contact_Activity: 'scroll_articles'
            })
        }, { once: true })
    }

    private addHistoryBackButton() {
        this.$backButton?.addEventListener('click', () => {
            const prevUrl = new URLSearchParams(this._windowObject.location.search).get(SupportPage.URL_PARAM_FOCUSSED_DIALOG_PREV_URL)
            if (prevUrl) {
                try {
                    const returnUrl = new URL(prevUrl, this._windowObject.location.origin)
                    if (returnUrl.origin === this._windowObject.location.origin) {
                        this._windowObject.location.assign(returnUrl.toString())
                        return
                    }
                } catch {
                    /*                                 */
                }
            }

            this._windowObject.history.back()
        })
    }

    static initialize(documentObject: Document, windowObject: Window = window): SupportPage {
        const supportPage: SupportPage = new SupportPage(documentObject, windowObject)
        supportPage.restoreLastScrollPositionIfAvailable()
        supportPage.initLoadMore()
        supportPage.bindScrollPositionRetention()
        supportPage.addHistoryBackButton()
        return supportPage
    }
}
export default SupportPage

